<template>
    <div>
        <Logo />
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <ion-input placeholder="Email" type="email" shape="round" expand="full" v-on:ionInput="setEmail($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                <ion-input placeholder="Password" type="password" shape="round" expand="full" v-on:ionInput="setPassword($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                <ion-button shape="round" expand="full" v-on:click="login()" style='margin-bottom: 12px;'>Login</ion-button>
                <div class="router-nav">
                    <router-link to="/password" class="">Forgot Password</router-link>
                </div>
                <ion-button shape="round" expand="full" v-on:click="register()" style='margin-top: 50px;'>Register Account</ion-button>
            </div>
        </div>
    </div>
</template>
<script>

import Logo from '@/components/Logo.vue'
import {alerts} from '../../mixins/alerts';
export default {
    name: 'login',
    data : function () {
        return {
            password : '',
            email    : ''
        }
    },
    components: {
        Logo
    },
    mixins : [alerts],
    methods : {
        getUserDetails : function () {
            let self = this;
            this.axios.post(this.api + 'auth/me')
                .then(response => {
                    console.debug('Retrieved User Details', response.data);
                    self.$root.setUser(response.data);
                    self.$router.push({ name : 'home' });
                })
                .catch(error => {
                    console.error('ERROR getting user details', error);
                });
        },
        register : function () {
            this.$router.push({name : 'register'});
        },
        login : function () {
            let self = this,
                params = {
                    email : this.email,
                    password : this.password
                };
            this.axios.post(this.api + 'auth/login', params)
                .then(response => {
                    // console.log('login', response.data);
                    self.$root.setUserToken(response.data.access_token);
                    self.getUserDetails();
                })
                .catch(error => {
                    console.error('ERROR logging in', error);
                    self.showError('Please check the details you provided and try again. Did you use the right password or email address?');
                });
        },
        setEmail : function (event) {
            this.email = event.target.value;
        },
        setPassword : function (event) {
            this.password = event.target.value;
        }
    }
}
</script>
